import React, {useEffect, useState} from "react";
import SideBar from "../../Navbars/SideBar";
import NavBar from "../../Navbars/NavBar";
import {
    MDBBox, MDBCard, MDBCardImage,
    MDBCol,
    MDBRow,
} from "mdbreact";
import {Alert, Card, Layout, Table, Tooltip} from "antd";
import {Text} from "react-font";
import Firebase from "../../../Firebase";
import { useHistory, useParams } from 'react-router-dom';
import {DollarIcon, IconButton, SearchInput} from "evergreen-ui";
import {useListVals} from "react-firebase-hooks/database";
import {useDocument} from "react-firebase-hooks/firestore";


const { Content } = Layout;
const outletsRef = Firebase.database().ref('System/Outlets');
const prodRef = Firebase.database().ref('System/Products');
var prodStoreRef = Firebase.storage().ref("System/Products");
const moment = require("moment");
var db = Firebase.firestore().collection("products");

const ViewOneProduct = (props) => {

    const columns = [
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: 'Outlet Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Stock Count',
            dataIndex: 'count',
            key: 'count',
        },{
            title: 'Units Sold',
            dataIndex: 'sold',
            key: 'sold',
        },
    ];

    const { id } = useParams();
    const history = useHistory();
    const [dataArray, setDataArray] = useState([]);
    const [outletArray, setOutletArray] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [outlets] = useListVals(outletsRef);
    const [checkedData, setCheckedData] = useState(true);
    const callback = (data) => {
        setCheckedData(data);
    }
    const [product, setProduct] = useState(null);
    const [productUrl, setProductUrl] = useState(props.location.state.url)
    const [snapshot, loading, error] = useDocument(
        db.doc(id),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );


    useEffect(() => {


        if(snapshot){
            const url = props.history.location.state?.url;
            setProductUrl(url);
            var object = snapshot.data();
            object["url"] = url ? url : "";
            setProduct(object);
        }

        if(error){
            //setMessage("Unable to show book Details occurred :: " + error.message);
            //setColor("danger");
            //setShowAlert(true);
        }
        /*
        if(props.location.product === undefined){
            gotoProducts()
        } else {
            //console.log(props.location.product);
            setDetails(props.location.product);
            var pID = props.location.product.productID;
            if(outlets){

                var tempArray = [];
                outlets.map((outlet, index) => {
                    //console.log(outlet);
                    var outP = outlet.products&&outlet.products[pID];
                    if(outP !== undefined){
                        tempArray.push({
                            key: index + 1,
                            name: outlet.name,
                            location : outlet.location,
                            count : outP.quantity,
                            sold : 0
                        });
                    }

                });
                //console.log(tempArray);
                setDataArray([...tempArray]);
                setOutletArray([...tempArray]);
            }
        }
        
         */


    }, [error, outlets, props, snapshot]);
    
    const gotoProducts = () => {
        history.push({
            pathname: '/products'
        });
    }

    function numberWithCommas(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const handleSearch = searchText => {
        const filteredEvents = outletArray.filter(({ name, location }) => {
            name = name.toLowerCase();
            location = location.toLowerCase();
            return name.includes(searchText) || location.includes(searchText);
        });

        setDataArray(filteredEvents);
    };

    return (

        <>

            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >
                        <MDBRow className="w-100">
                            <MDBCol md={12}>

                                <Card className="w-100">

                                    <MDBRow>
                                        <MDBCol md={12} className="w-100">
                                            <div className="text-left">
                                                <div className="d-block">
                                                    <h5 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            {props.location.product !== undefined ?
                                                                "Product : " + props.location.product.name
                                                                : null}
                                                        </Text>
                                                    </h5>
                                                </div>
                                            </div>
                                        </MDBCol>

                                    </MDBRow>

                                </Card>

                                <MDBBox className="p-3">
                                    <MDBRow>
                                        <Card bordered={false} className="w-100 mr-2">
                                            <div className="text-left">
                                                <div className="d-flex justify-content-between">
                                                    <h6 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            Details
                                                        </Text>
                                                    </h6>
                                                    <Tooltip placement="bottom" title="Product Sales">
                                                        <IconButton icon={DollarIcon} intent="success" className="mr-1" onClick={() => {
                                                            history.push({
                                                                pathname: '/sales',
                                                                filter: product.name,
                                                            });
                                                        }}/>
                                                    </Tooltip>
                                                </div>
                                                <hr/>
                                                <div className="py-1">
                                                    <MDBRow>
                                                        <MDBRow className="w-100">
                                                            <MDBCol md={4}>
                                                                <MDBCard className="w-100 m-1 d-flex justify-content-center align-items-center">
                                                                    <MDBCardImage className="img-fluid" style={{width: "18rem", height: "19rem"}}
                                                                                  src={product&&product.url} waves/>
                                                                </MDBCard>
                                                            </MDBCol>
                                                            <MDBCol>
                                                                <div className="d-flex flex-column">
                                                                    <Alert message={<><b>Name: </b>{product&&product.name}</>}
                                                                           className="w-100 my-1" type="info" showIcon />
                                                                    <Alert message={<><b>Price: </b>{product ? "K " + numberWithCommas(product.price) : null}</>}
                                                                           className="w-100 my-1" type="info" showIcon />
                                                                    <Alert message={<><b>Type: </b>{product&&product.productType}</>}
                                                                           className="w-100 my-1" type="info" showIcon />
                                                                    <Alert message={<><b>Stock: </b>{product&&product.stockCount}</>}
                                                                           className="w-100 my-1" type="info" showIcon />
                                                                    <Alert message={<><b>Date created: </b>{product&&moment(product.dateCreated, "YYYY-MM-DDTh:mm:ss").format("DD MMM YYYY")}</>}
                                                                           className="w-100 my-1" type="info" showIcon />
                                                                    <Alert message={<>{product&&product.description}</>}
                                                                           className="w-100 my-1" type="info" showIcon />

                                                                </div>
                                                            </MDBCol>

                                                        </MDBRow>
                                                    </MDBRow>
                                                </div>
                                            </div>

                                        </Card>

                                    </MDBRow>
                                    <MDBRow>
                                        <Card bordered={false} className="w-100 mt-3 mr-2">
                                            <div>
                                                <MDBRow>
                                                    <MDBCol>
                                                        <h6 className="font-weight-bold">
                                                            <Text family='Nunito'>
                                                                Outlets Selling
                                                            </Text>
                                                        </h6>
                                                    </MDBCol>
                                                    <MDBCol md={3}>
                                                        <SearchInput height={30} placeholder="Search outlets" className="w-100"
                                                                     onChange={e => handleSearch(e.target.value)} />
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr/>
                                            </div>
                                            <div className="mt-4 py-1">
                                                <MDBRow>
                                                    <MDBRow className="w-100">
                                                        <MDBCol>
                                                            <MDBCard className="m-2 p-3 w-100">
                                                                <div>
                                                                    <Table style={{overflow: "auto"}} id={"dataTable"} loading={tableLoading} dataSource={dataArray} columns={columns} />
                                                                </div>
                                                            </MDBCard>
                                                        </MDBCol>

                                                    </MDBRow>
                                                </MDBRow>
                                            </div>


                                        </Card>
                                    </MDBRow>

                                </MDBBox>

                            </MDBCol>
                        </MDBRow>
                    </Content>
                </Layout>
            </Layout>

        </>
    )

}

export default ViewOneProduct;
